'use client';
import { Box } from '@instamenu/ui-system-next';
import React from 'react';
import { useLocation } from '@instamenu/react-hooks';
import { Location } from '@instamenu/ui-storefront';
import haversine from 'haversine-distance';
import { RestaurantsQuery } from '@/queries/queries-restaurants/queries.ssr.generated';

const RestaurantLocation = ({ data }: { data: RestaurantsQuery }) => {
  const { coordinates } = useLocation();
  if (!data) return null;

  const withDistance = data.restaurants
    .map((restaurant) => ({
      ...restaurant,
      distance:
        coordinates && restaurant.address?.location
          ? haversine(restaurant.address.location, coordinates)
          : undefined,
    }))
    .sort(
      (a, b) =>
        (a.distance ?? Number.POSITIVE_INFINITY) - (b.distance ?? Number.POSITIVE_INFINITY) ||
        (a.name ?? '').localeCompare(b.name ?? ''),
    );

  return (
    <Box>
      {withDistance.map((restaurant) => (
        <Location key={restaurant.id} restaurant={restaurant} />
      ))}
    </Box>
  );
};

export default RestaurantLocation;
